import React, {useState} from 'react';
import {Button, Menu, MenuItem} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import {Language} from '@material-ui/icons';

function LanguageSelector({appState, container}) {
  const {i18n} = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const changeLang = lang => {
    setAnchorEl(null);
    if (lang !== i18n.language) i18n.changeLanguage(lang);
  };

  return (
    <>
      <Button
        aria-controls="lang-menu"
        aria-haspopup="true"
        color="inherit"
        variant="outlined"
        size="small"
        onClick={e => setAnchorEl(e.currentTarget)}
        startIcon={<Language />}
      >
        {i18n.language}
      </Button>
      <Menu
        id="lang-menu"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        container={container || document.body}
        keepMounted
        style={{zIndex: 1500, marginTop: '5px'}}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {appState.conf.LANGS.map(lang => (
          <MenuItem key={lang} onClick={() => changeLang(lang)}>
            {lang}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default LanguageSelector;
